import React, { memo } from "react"
import clsx from "clsx"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import PersonPill from "./PersonPill"
import { usePlanning } from "./PlanningContext"
import useDropTarget from "../hooks/useDropTarget"

const ACCEPTS = ["person", "assignment"]

const ProjectCell = ({ projectId, date, tone, items, selectedKey, color }) => {
  const { handlers, density, canWrite } = usePlanning()
  const { over, dropProps } = useDropTarget({
    accepts: ACCEPTS,
    blocked: false,
    onDrop: (drag, altKey) => handlers.dropOnProject({ projectId, date, drag, altKey }),
  })
  const selected = selectedKey ? selectedKey.split(",") : []

  return (
    <div
      {...(canWrite ? dropProps : {})}
      onClick={canWrite ? event => handlers.clickProjectCell({ projectId, date, event }) : undefined}
      className={clsx(
        "pp-drop group/cell relative p-1 border-r border-b border-slate-100 transition-colors",
        density === "compact" ? "min-h-[46px] flex flex-wrap content-start gap-0.5" : "min-h-[54px] flex flex-col gap-1",
        tone,
        canWrite && "cursor-cell",
        over && "pp-over bg-brand-50 ring-2 ring-inset ring-brand-400",
      )}
      style={items.length ? { boxShadow: `inset 0 2px 0 ${color}` } : undefined}
    >
      {items.map(item => <PersonPill key={item.id} assignment={item} selected={selected.includes(String(item.id))} />)}
      {canWrite && items.length === 0 && !over && (
        <span className="pp-drop-hint absolute inset-0 grid place-items-center text-slate-300 opacity-0 group-hover/cell:opacity-100 transition-opacity pointer-events-none">
          <FontAwesomeIcon icon="plus" className="text-[11px]" />
        </span>
      )}
    </div>
  )
}

export default memo(ProjectCell)
